document.addEventListener("DOMContentLoaded", function () {
  var _Cookiebot$consent;

  function loadFillout() {
    if (document.getElementById('fillout-embed-script')) return;
    var s = document.createElement('script');
    s.id = 'fillout-embed-script';
    s.src = 'https://server.fillout.com/embed/v1/';
    s.async = true;
    document.body.appendChild(s);
  }

  if (window.Cookiebot && (_Cookiebot$consent = Cookiebot.consent) !== null && _Cookiebot$consent !== void 0 && _Cookiebot$consent.preferences) {
    loadFillout();
  } else {
    window.addEventListener('CookiebotOnAccept', function () {
      var _Cookiebot$consent2;

      if ((_Cookiebot$consent2 = Cookiebot.consent) !== null && _Cookiebot$consent2 !== void 0 && _Cookiebot$consent2.preferences) {
        loadFillout();
      }
    });
  }
});